import { render, staticRenderFns } from "./ReqAbiertasComponent.vue?vue&type=template&id=661cffa9&"
import script from "./ReqAbiertasComponent.vue?vue&type=script&lang=js&"
export * from "./ReqAbiertasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports